import { Button } from "@chakra-ui/react";
import { Empty } from "antd";
import { useCurrentAuth } from "core/features/auth/auth.store";

import { Box, SimpleGrid, Flex, Image } from "@chakra-ui/react";
import useLogout from "core/features/auth/logout/useLogout";
import mascoteImg from "assets/images/Polvo-mascote.png";
import telasBg from "assets/images/telas-bg.png";
import TenantItem from "ui/components/Cards/Card1Vertical";
import { useCurrentTenant } from "core/features/auth/tenant.store";

function SelecionarCondominio() {
  const { auth: authData } = useCurrentAuth();
  const { selecionar } = useCurrentTenant();
  const { handleLogout } = useLogout();

  return (
    <Box
      d="flex"
      minH="100vh"
      bgColor="#f7f7f7"
      bgImage={telasBg}
      bgPos="left bottom"
      bgSize="100% 550px"
      bgRepeat="no-repeat"
      overflowY="auto"
      justifyContent="center"
    >
      <Box mt="16px" p="16px" maxW="1200px" w="100%">
        <Flex flexDir="row">
          <Flex flex={1} />
          <Flex flexDir="column">
            <Box mb="48px">
              <Button
                float="right"
                variant="outline"
                bg="white"
                size="lg"
                onClick={() => {
                  handleLogout();
                }}
              >
                Sair
              </Button>
            </Box>

            <Image w="150px" src={mascoteImg} />
          </Flex>
        </Flex>

        {!authData.tenants?.length ? (
          <>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </>
        ) : (
          <Box fontSize="22px" pb="16px">
            Selecione uma empresa
          </Box>
        )}

        <SimpleGrid columns={{ sm: 1, md: 2, lg: 4 }} gap="16px">
          {authData.tenants?.map((item, key) => (
            <TenantItem
              key={key}
              name={item.nome}
              description={item.tipoTenant}
              icon={
                item.imagemUrl ? (
                  <Box
                    border="1px solid #efefef"
                    bgColor="white"
                    bgImage={item.imagemUrl}
                    bgSize="100% auto"
                    bgPos="center"
                    bgRepeat="no-repeat"
                    w="50px"
                    h="50px"
                    rounded="full"
                  />
                ) : null
              }
              complete={!true}
              onClick={() => {
                selecionar(item);

                if (item.finishOnboardingDate === null) {
                  setTimeout(() => {
                    window.location.href = "/onboarding/primeiro-passo";
                  }, 500);
                } else {
                  setTimeout(() => {
                    window.location.href = "/";
                  }, 500);
                }
              }}
            />
          ))}
        </SimpleGrid>
      </Box>
    </Box>
  );
}

export default SelecionarCondominio;
